import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, round } from 'lodash';

import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moDemandPdf from '../store';

interface IProps {}
interface IState {}

const IndustryTrendTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { trendQuarter } = moDemandPdf;

  useEffect(() => {
    return () => {};
  }, []);

  const colorList = [
    '',
    Color.primary,
    Color.secondary,
    Color.two,
    Color.error,
  ];

  return (
    <section className="industry-table-warp">
      <section className="table-title">
        {[
          '',
          '招聘量',
          '招聘量环比变化',
          '平均月薪（元）',
          '招聘薪酬环比变化',
        ].map((res: any, i: any) => {
          return (
            <p key={i} style={{ background: colorList[i] }}>
              {res}
            </p>
          );
        })}
      </section>
      <section className="table-content">
        {trendQuarter?.map((res: any, i: any) => {
          return (
            <p key={i}>
              <span>{res.time_str}</span>
              <span>{res.amount?.toLocaleString()}</span>
              <span
                style={{
                  background: res.amount_change > 0 ? '#FBE8E8' : '#E5F9F3',
                  color: res.amount_change > 0 ? Color.error : Color.success,
                }}>
                {`${round(res.amount_change * 100, 1)}%`}
              </span>
              <span>{res.salary?.toLocaleString()}</span>
              <span
                style={{
                  background: res.salary_change > 0 ? '#FBE8E8' : '#E5F9F3',
                  color: res.salary_change > 0 ? Color.error : Color.success,
                }}>
                {`${round(res.salary_change * 100, 1)}%`}
              </span>
            </p>
          );
        })}
      </section>
    </section>
  );
};

export default observer(IndustryTrendTable);
